import { useMutation } from 'react-query';

import { deleteMapping } from 'api/endPoints/deleteMapping';

import { IDeleteMappingParams } from 'components/Dashboards/Portfolio/phasePerformance/manage/manage.types';

export const useMutationDeleteMapping = () => {
    return useMutation<unknown, QueryError, IDeleteMappingParams>((params) => deleteMapping(params));
};
